import type { FaqSection } from "./types";

const installersAndEPCsSection: FaqSection = {
  id: "installers-epcs",
  title: "Installers & EPCs",
  faqs: [
    {
      question: "How does Enerflo help solar Installers and EPCs?",
      answer: (
        <p>
          Enerflo automates project intake, reduces errors, and keeps all stakeholders on the same page. Installers can
          track permits, inspections, and utility approvals in Install Tracker.
        </p>
      ),
    },
    {
      question: "Can Installers manage Sales Dealer relationships in Enerflo?",
      answer: (
        <p>
          Yes. Installers can onboard Sales Dealers into Enerflo, provide custom pricing, and receive accurate project
          data directly from dealer submissions.
        </p>
      ),
    },
    {
      question: "Does Enerflo support in-house design teams?",
      answer: (
        <p>
          Yes. Enerflo integrates with Aerialytic and other design tools, such as Aurora, allowing in-house designers to
          create, approve, and attach designs directly to proposals.
        </p>
      ),
    },
    {
      question: "Can Installers see financing details in Enerflo?",
      answer: (
        <p>
          Yes. With lender integrations, installers can see approved financing terms, ensuring alignment between sales
          and installation teams.
        </p>
      ),
    },
    {
      question: "How does Enerflo reduce project delays for installers?",
      answer: (
        <p>
          By using Title Checks, Smart Pulls, and automated document validation, Enerflo catches errors before they
          cause downstream issues.
        </p>
      ),
    },
  ],
};

export default installersAndEPCsSection;
